import {DateTimeFormatter, LocalDate as LocalDate, LocalDateTime, Duration} from "@js-joda/core";
LocalDate.LocalDate;


let addIntForDate = (num) => num >= 10 ? num : '0' + num;

class TimeRangeManager {

    shortenDisplay(parsedDate) {
        if (!parsedDate) return `Invalid Date : ${parsedDate}`
        return parsedDate;
    }

    shortJavaDateTimeObject(javaDateTimeObject) {
        let date = javaDateTimeObject.date;
        let time = javaDateTimeObject.time;
        let parsedDate = `${date.year}-${addIntForDate(date.month)}-${addIntForDate(date.day)} ${addIntForDate(time.hour)}:${addIntForDate(time.minute)}:${addIntForDate(time.minute)}`;
        return this.shortenDisplay(parsedDate);
    }

    getNow() {
        let today = LocalDate.now();
        today = today._year + '-' + addIntForDate(today._month) + '-' + addIntForDate(today._day);
        return today;
    }

    getThisMoment() {
        let date = LocalDateTime.now().format(DateTimeFormatter.ofPattern("yyyy-MM-dd"));
        let time = LocalDateTime.now().format(DateTimeFormatter.ofPattern("hh:mm"));
        return date+`T`+time;
    }

    getNowMinusDays(days) {
        let today = LocalDate.now().minusDays(days);
        today = today._year + '-' + addIntForDate(today._month) + '-' + addIntForDate(today._day);
        return today;
    }

    getToday() {
        let today = LocalDate.now();
        today = today._year + '-' + addIntForDate(today._month) + '-' + addIntForDate(today._day);
        let tomorrowDate = LocalDate.now().plusDays(1);
        let tomorrow = tomorrowDate._year + '-' + addIntForDate(tomorrowDate._month) + '-' + addIntForDate(tomorrowDate._day);
        return {from: today, to: tomorrow}
    }

    getYesterday() {
        let today = LocalDate.now();
        today = today._year + '-' + addIntForDate(today._month) + '-' + addIntForDate(today._day);
        let yesterdayDate = LocalDate.now().minusDays(1);
        let yesterday = yesterdayDate._year + '-' + addIntForDate(yesterdayDate._month) + '-' + addIntForDate(yesterdayDate._day);
        return {from: yesterday, to: today}
    }

    getLastWeek() {
        let startOfWeek = LocalDate.now().minusDays(7);
        startOfWeek = startOfWeek._year + '-' + addIntForDate(startOfWeek._month) + '-' + addIntForDate(startOfWeek._day)
        let tomorrowDate = LocalDate.now().plusDays(1);
        let tomorrow = tomorrowDate._year + '-' + addIntForDate(tomorrowDate._month) + '-' + addIntForDate(tomorrowDate._day);
        return {from: startOfWeek, to: tomorrow}
    }


    getThisMonth() {
        let startOfMonth = LocalDate.now().withDayOfMonth(1)
            .format(DateTimeFormatter.ofPattern("yyyy-MM-dd"));
        let tomorrowDate = LocalDate.now().plusDays(1);
        let tomorrow = tomorrowDate._year + '-' + addIntForDate(tomorrowDate._month) + '-' + addIntForDate(tomorrowDate._day);
        return {from: startOfMonth, to: tomorrow}
    }

    getPreviousMonth() {
        let firstDayOfLastMonth = LocalDate.now().minusMonths(1);
        firstDayOfLastMonth = firstDayOfLastMonth._year+'-'+addIntForDate(firstDayOfLastMonth._month)+'-01'

        let now = LocalDate.now();
        let firstDayOfThisMonth = now._year + '-' + addIntForDate(now._month) + '-01';

        return { from : firstDayOfLastMonth,to : firstDayOfThisMonth}
    }

    getThisYear() {
        let startOfYear = LocalDate.now()._year + '-01-01'
        let tomorrowDate = LocalDate.now().plusDays(1);
        let tomorrow = tomorrowDate._year + '-' + addIntForDate(tomorrowDate._month) + '-' + addIntForDate(tomorrowDate._day);
        return {from: startOfYear, to: tomorrow}
    }

    getForNoOfDays(noOfDays) {
        let startOfWeek = LocalDate.now().minusDays(noOfDays);
        startOfWeek = startOfWeek._year + '-' + addIntForDate(startOfWeek._month) + '-' + addIntForDate(startOfWeek._day)
        let tomorrowDate = LocalDate.now().plusDays(1);
        let tomorrow = tomorrowDate._year + '-' + addIntForDate(tomorrowDate._month) + '-' + addIntForDate(tomorrowDate._day);
        return {from: startOfWeek, to: tomorrow}
    }

    getDateDiff(date1, date2) {
        date1 = LocalDateTime.parse(date1 + ' 00:00:00', DateTimeFormatter.ofPattern("yyyy-MM-dd HH:mm:ss"))
        date2 = LocalDateTime.parse(date2 + ' 00:00:00', DateTimeFormatter.ofPattern("yyyy-MM-dd HH:mm:ss"))
        let duration = Duration.between(date1, date2);
        return duration.toDays();
    }

    isGreaterThanTwoMonths(range) {
        return this.getDateDiff(range.from, range.to) >= 60;
    }

}

export default TimeRangeManager = new TimeRangeManager();
